import { Tag } from "@design-system/Tag/Tag";
import styles from "./ChatDragPreview.module.scss";

/** The chip that follows the pointer while rows are dragged to the chat, e.g. "3 transactions". */
export const ChatDragPreview = ({ label }: { label: string }) => (
    <Tag size="lg" color="accent" className={styles.preview}>
        {label}
    </Tag>
);
